module.exports = __webpack_public_path__ + "static/media/nirveda-logo.32eb78c4.png";